
<template>
  <v-container fill-height fluid>
    <v-layout style="position: fixed; top: 5px; left: 5px;">
      <v-btn light outline @click="$router.push('/')">
        <v-icon>keyboard_arrow_left</v-icon>Home
      </v-btn>
      <v-btn v-if="isParent" light outline @click="settingsDialog = true">
        <v-icon>settings</v-icon>
      </v-btn>
    </v-layout>
    <v-layout row wrap justify-end fill-height>
      <v-flex xs12>
        <div
          class="text-xs-center"
          :style="`${$vuetify.breakpoint.mdAndUp ? 'position: fixed; left: 10%; top: 10%;' : ''}`"
        >
          <Avatar :id="parent"/>
          <div class="headline">
            <span style="font-weight:bold">{{ baby ? baby.name : 'loading' }}</span>
          </div>
          <v-layout justify-space-between>
            <v-btn @click="$router.push('timeline')" outline>Timeline</v-btn>
            <v-badge color="red" overlap v-if="isParent">
              <span v-if="unauthorized_requests > 0" slot="badge">{{unauthorized_requests}}</span>
              <v-btn @click="$router.push('users')" outline>Participants</v-btn>
            </v-badge>
            <v-btn @click="$router.push('pronos')" outline>Pronos</v-btn>
            <v-btn @click="$router.push('stats')" outline>Stats</v-btn>
          </v-layout>
          <v-layout justify-center>
            <v-btn
              v-if="isParent && !babyIsBorn"
              outline
              block
              @click="bornDialog = true"
            >baby is born !</v-btn>
            <v-card v-if="babyIsBorn" class="elevation-2" width="100%">
              <v-card-title>Baby is born !
                <v-spacer/>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-btn icon slot="activator">
                    <v-icon>event</v-icon>
                  </v-btn>
                  <v-date-picker :value="convertDate(born.date)" no-title readonly scrollable></v-date-picker>
                </v-menu>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="position: relative;">
                <Viewer
                  :weight="born.weight"
                  :height="born.height"
                  :gender="born.gender"
                  :color="born.color"
                />
                <v-expand-transition>
                  <div
                    class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal display-3 white--text"
                    style="position: absolute; left: 0px; top: 0px; height: 100%; width: 100%; opacity: 0.3;"
                  >
                    <v-list>
                      <v-list-tile>{{ born.gender}}</v-list-tile>
                      <v-list-tile>{{ born.weight / 1000}}kg</v-list-tile>
                      <v-list-tile>{{ born.height}}cm</v-list-tile>
                    </v-list>
                  </div>
                </v-expand-transition>
              </v-card-text>
            </v-card>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 md10>
        <router-view
          :pronos="pronos"
          :isParent="isParent"
          :users="users"
          :born="born"
          :requests="requests"
          @delete="deleteProno"
        />
      </v-flex>
    </v-layout>
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Do you really want to delete this pronostic ?</v-card-title>

        <v-card-text>This action cannot be reverted.</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="deleteDialog = false">Disagree</v-btn>

          <v-btn color="green darken-1" flat="flat" @click="deletePronoConfirmed">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="settingsDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Settings</v-card-title>

        <v-card-text>
          <v-switch label="Pronostics enabled" v-model="pronosticsEnabled"></v-switch>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn flat @click="closeSettings">Cancel</v-btn>

          <v-btn color="green darken-1" :loading="settingsLoading" raised dark @click="saveSettings">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="scoreDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Score</v-card-title>

        <v-card-text>
          Congratulations ! Check the
          <span>Pronos</span> panel to see the ranking
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn flat @click="scoreDialog = false">Ok !</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bornDialog" max-width="70%">
      <v-card>
        <v-card-title class="headline">Baby is born !</v-card-title>

        <v-card-text>
          <Editor @save="saveBorn"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import { firebase, firestore, auth, storage, ui, uiConfig, fieldValue } from "@/firebase";
import Avatar from "@/components/user/Avatar";
import Editor from "@/components/baby/Editor";
import Viewer from "@/components/baby/Viewer";

export default {
  data() {
    return {
      baby: null,
      pronos: [],
      requests: [],
      user: null,
      users: {},
      deleteDialog: false,
      settingsDialog: false,
      settingsLoading: false,
      scoreDialog: false,
      bornDialog: false,
      pronosticsEnabled: true
    };
  },
  beforeRouteEnter(to, from, next) {
    const redirect_dashboard = () => {
      if (to.name === "dashboard-prono" || to.name === "dashboard-request") {
        next({
          name: "dashboard-timeline",
          params: {
            id: to.params.id
          }
        });
      } else {
        next();
      }
    };
    const redirect_prono = () => {
      if (to.name === "dashboard-prono") {
        next();
      } else {
        next({
          name: "dashboard-prono",
          params: {
            id: to.params.id
          }
        });
      }
    };
    const redirect_authorized = (user, born) => {
      if (born) {
        redirect_dashboard();
      } else {
        firestore
          .collection("babies")
          .doc(to.params.id)
          .collection("pronos")
          .doc(user.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              redirect_dashboard();
            } else {
              redirect_prono();
            }
          })
          .catch(err => {
            console.error(err);
            redirect_prono();
          });
      }
    };
    const redirect_user = user => {
      firestore
        .collection("babies")
        .doc(to.params.id)
        .get()
        .then(doc => {
          if (doc.exists) {
            if (doc.data().parent === user.uid) {
              next();
            } else {
              firestore
                .collection("babies")
                .doc(to.params.id)
                .collection("requests")
                .doc(user.uid)
                .get()
                .then(prono => {
                  if (prono.exists && prono.data().authorized) {
                    redirect_authorized(user, doc.data().born);
                  } else {
                    if (to.name === "dashboard-request") {
                      next();
                    } else {
                      next({
                        name: "dashboard-request",
                        params: {
                          id: to.params.id,
                          privacy: doc.data().privacy
                        }
                      });
                    }
                  }
                });
            }
          } else {
            next("/");
          }
        })
        .catch(err => {
          if (to.name === "dashboard-request") {
            next();
          } else {
            next({
              name: "dashboard-request",
              params: {
                id: to.params.id,
                privacy: "private"
              }
            });
          }
        });
    };
    auth.onAuthStateChanged(user => {
      if (user) {
        redirect_user(user);
      } else {
        ui.start("#firebaseui-auth-container", {
          ...uiConfig,
          callbacks: {
            signInSuccessWithAuthResult: ({ user }) => {
              redirect_user(user);
            }
          }
        });
      }
    });
  },
  mounted() {
    this.bind(this.$route.params.id);
    auth.onAuthStateChanged(user => {
      this.user = user;
    });
  },
  methods: {
    bind(id) {
      if (id) {
        this.$bind("baby", firestore.collection("babies").doc(id));
        this.$bind(
          "pronos",
          firestore
            .collection("babies")
            .doc(id)
            .collection("pronos")
        );
        this.$bind(
          "requests",
          firestore
            .collection("babies")
            .doc(id)
            .collection("requests")
        );
      }
    },
    convertDate(date) {
      return new Date(date.seconds * 1000).toISOString().split("T")[0];
    },
    deleteProno(id) {
      this.deleteDialog = true;
      this.pronoToDelete = id;
    },
    deletePronoConfirmed() {
      this.deleteDialog = false;
      firestore
        .collection("babies")
        .doc(this.$route.params.id)
        .collection("pronos")
        .doc(this.pronoToDelete)
        .delete();
    },
    saveBorn(born) {
      firestore
        .collection("babies")
        .doc(this.$route.params.id)
        .update({
          born
        });
      this.bornDialog = false;
      this.scoreDialog = true;
    },
    async saveSettings() {
      this.settingsLoading = true;
      await firestore
        .collection("babies")
        .doc(this.$route.params.id)
        .update({
          disabled: this.pronosticsEnabled ? fieldValue.delete():true
        });
      this.settingsLoading = false;
      this.closeSettings();
    },
    closeSettings() {
      this.pronosticsEnabled = !this.baby.disabled
      this.settingsDialog = false;
    }
  },
  computed: {
    parent() {
      return this.baby ? this.baby.parent : undefined;
    },
    born() {
      return this.baby ? this.baby.born : undefined;
    },
    isParent() {
      return this.user ? this.parent === this.user.uid : false;
    },
    babyIsBorn() {
      return !!this.born;
    },
    unauthorized_requests() {
      return this.requests.filter(request => !request.authorized).length;
    }
  },
  watch: {
    "$route.params.id": function(id) {
      this.bind(id);
    },
    async baby(baby) {
      this.loading = false;
      this.selectedDate = this.convertDate(baby.date);
      this.pronosticsEnabled = !baby.disabled
      this.pictures = await Promise.all(
        baby.pictures.map(ref => storage.ref(ref).getDownloadURL())
      );
    },
    async pronos(pronos) {
      this.users = {};
      pronos.forEach(async prono => {
        const doc = await firestore
          .collection("users")
          .doc(prono.id)
          .get();
        this.$set(this.users, prono.id, doc.data());
      });
    }
  },
  components: {
    Avatar,
    Editor,
    Viewer
  }
};
</script>